import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { Input, Button, Form, Alert, Card } from "antd";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        const auth = getAuth();

        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;
            console.log("Logged in:", user.email);
            navigate("/admin"); // Redirect to admin page
        } catch (error) {
            console.error("Login failed:", error.message);
            setError("Login failed: " + error.message);
        }
    };

    return (
        <div className="login-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
            <Card 
                title="Admin Login" 
                bordered={false} 
                style={{ width: 400, padding: '20px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', backgroundColor: '#ffffff' }}
            >
                <Form onSubmitCapture={handleLogin}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, message: "Please input your email!" }, { type: "email", message: "The input is not a valid email!" }]}
                    >
                        <Input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            style={{ borderRadius: 8 }}
                        />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: "Please input your password!" }]}
                    >
                        <Input.Password
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            style={{ borderRadius: 8 }}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            style={{
                                backgroundColor: '#4CAF50',
                                borderColor: '#4CAF50',
                                borderRadius: 8,
                                fontSize: '16px',
                                padding: '12px 0',
                            }}
                        >
                            Login
                        </Button>
                    </Form.Item>
                </Form>

                {error && (
                    <Alert
                        message={error}
                        type="error"
                        showIcon
                        style={{ marginTop: '15px' }}
                    />
                )}
            </Card>
        </div>
    );
}
